export default __webpack_public_path__ + "static/wohnbau-derr-2de6a2db7fcc1e2f8ff80244187f194a.jpg";